exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n*[data-v-72ff2424] {\n  font-family: Moderat;\n  font-style: normal;\n  font-weight: normal;\n}\n.loader-container[data-v-72ff2424] {\n  height: calc(100vh - 80px);\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.loading-wrapper[data-v-72ff2424] {\n  width: 400px;\n}\n.wrapper[data-v-72ff2424] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n", ""]);

// exports
